export default __webpack_public_path__ + "static/media/spinachsupercocktail@2x.29ca4934.jpg";